import { render } from "./DashboardMonitoring.vue?vue&type=template&id=1877aed2&scoped=true"
import script from "./DashboardMonitoring.vue?vue&type=script&lang=js"
export * from "./DashboardMonitoring.vue?vue&type=script&lang=js"

import "./DashboardMonitoring.vue?vue&type=style&index=0&id=1877aed2&scoped=true&lang=css"
import "./DashboardMonitoring.vue?vue&type=style&index=1&id=1877aed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1877aed2"]])

export default __exports__